var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6417 1.19409C12.2274 1.15203 11.8054 1.13037 11.3771 1.13037C5.79001 1.13037 1.26074 4.81744 1.26074 9.36566C1.26074 13.9139 5.79001 17.601 11.3771 17.601C12.2504 17.601 13.0979 17.5109 13.9062 17.3415L17.6999 21.1304V15.8363C19.403 14.6846 20.7716 12.9541 21.2607 11.1304M21.2607 5.50537C21.2607 7.23126 19.8616 8.63037 18.1357 8.63037C16.4099 8.63037 15.0107 7.23126 15.0107 5.50537C15.0107 3.77948 16.4099 2.38037 18.1357 2.38037C19.8616 2.38037 21.2607 3.77948 21.2607 5.50537Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBot);
export default __webpack_public_path__ + "static/media/default-bot.f3fdd1f8e660fe6fa00acb66cfe2e3ac.svg";
export { ForwardRef as ReactComponent };